import React, { useEffect } from "react";
import "./App.css";
import { Switch, Route } from "react-router-dom";
import {
  MuiThemeProvider,
  createMuiTheme,
  CircularProgress,
} from "@material-ui/core";
import NavBar from "./components/NavBar.js";
import Property from "./components/property/Property.js";
import Cart from "./components/property/Cart.js";
import NotAuthorized from "./components/NotAuthorized.js";

import { Context as AuthContext } from "./context/auth.context";
import { Provider as CartProvider } from "./context/cart.context";
import { Provider as PropertyProvider } from "./context/property.context";

const theme = createMuiTheme({
  palette: {
    primary: {
      // main: "#DB2339",
      // main: "linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%);",
      main: "#009ade",
    },
    secondary: {
      main: "#009ade",
    },
  },
  status: {
    danger: "orange",
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        borderRadius: 6,
      },
      notchedOutline: {
        borderColor: "rgb(211,220,224)",
      },
    },
    MuiStepIcon: {
      root: {
        "&$completed": {
          color: "#84BD00",
        },
        "&$active": {
          color: "#84BD00",
        },
      },
    },
  },
});

function App() {
  const { state, hydrateTerminal } = React.useContext(AuthContext);

  useEffect(() => {
    hydrateTerminal();
  }, []);

  if (state.appLoading) {
    return (
      <MuiThemeProvider theme={theme}>
        <div
          style={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="primary" />
        </div>
      </MuiThemeProvider>
    );
  } else {
    if (state.opIDValid) {
      if (state.hydrateError) {
        return <div>hydrate error!</div>;
      } else {
        return (
          <div className="App">
            <MuiThemeProvider theme={theme}>
              <CartProvider>
                <NavBar />
                <Switch>
                  <Route path="/:opID">
                    <PropertyProvider>
                      <Property theme={theme} />
                    </PropertyProvider>
                    <Cart />
                  </Route>
                </Switch>
              </CartProvider>
            </MuiThemeProvider>
          </div>
        );
      }
    } else {
      return <NotAuthorized />;
    }
  }
}

export default App;
